import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { componentsBranding, mobileComponents } from 'constants/branding';
import useDevice from 'hooks/useDevice';

import styles from './styles.module.scss';

interface WelcomePopupProps {
  onLearnMore: () => void;
}

const WelcomePopup = ({ onLearnMore }: WelcomePopupProps) => {
  const { t } = useTranslation();
  const { isMobile } = useDevice();

  return (
    <>
      <div
        className={classNames(styles.welcomePopup__body__text, { [styles.welcomePopup__body__text__mobile]: isMobile })}
      >
        {t('dialog.welcome.text')}
      </div>
      <button
        type="button"
        onClick={onLearnMore}
        className={classNames(styles.welcomePopup__body__button, {
          [styles.welcomePopup__body__button__mobile]: isMobile,
          [componentsBranding.TERTIARY_BTN]: !isMobile,
          [mobileComponents.BUTTON]: isMobile,
          [mobileComponents.TERTIARY]: isMobile
        })}
      >
        {t('dialog.welcome.button')}
      </button>
    </>
  );
};

export default WelcomePopup;
